import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ReportSalesMonthlyResponseV4Schema } from "../response/ReportSalesMonthlyResponseV4";

const API_VERSION = 'v4';

interface FilterPropsV4 {
    property_id: string;
    base_on: "created_reservation";
    room_type_id?: string;
}

interface ReportSalesMonthlyV4Props {
    filter: FilterPropsV4;
    type: string | null;
}

const useReportSalesMonthlyV4 = (params: ReportSalesMonthlyV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'sales-monthly-v4',
            params.type,
            JSON.stringify(params.filter)
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/channel-manager/property-report-reservation`, {
                    params: { filter: params.filter }
                });

                const validationResult = ReportSalesMonthlyResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid V4 Sales Monthly report data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch V4 Sales Monthly report`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && params.type === "report_sales_monthly",
        retry: 1,
        refetchOnWindowFocus: false,
    });
};

export default useReportSalesMonthlyV4;